/**
 * mobileNav — drawer open/close + drill-down panel state.
 *
 * Open/close is backed by the shared `nav` store so the header burger and the
 * drawer share one source of truth. The drill-down (Figma Menu/Mobile Level 1 →
 * Level 2) is local component state: `activePanel` holds the key of the open
 * sub-panel, or null at the root. Opening a parent pushes its panel; "Back To
 * Menu" pops to the root. Closing the drawer always resets to the root so it
 * reopens at the top level.
 */
export default function mobileNav() {
    return {
        // Which sub-panel is showing; null = root list.
        activePanel: null,

        get isOpen() {
            return this.$store.nav.mobileOpen;
        },

        get isClosed() {
            return !this.$store.nav.mobileOpen;
        },

        get expandedAttr() {
            return String(this.$store.nav.mobileOpen);
        },

        get atRoot() {
            return this.activePanel === null;
        },

        open() {
            this.$store.nav.mobileOpen = true;
        },

        close() {
            this.$store.nav.mobileOpen = false;
            // Reset to root so the next open starts at the top level.
            this.activePanel = null;
        },

        toggle() {
            if (this.$store.nav.mobileOpen) {
                this.close();
            } else {
                this.open();
            }
        },

        // Drill into a parent's sub-panel.
        openPanel(key) {
            this.activePanel = key;
        },

        // Pop back to the root list.
        backToMenu() {
            this.activePanel = null;
        },

        // Whether a given sub-panel is the active one.
        isPanel(key) {
            return this.activePanel === key;
        },

        init() {},
        destroy() {},
    };
}
